import { render, staticRenderFns } from "./ProcessNachtragHeader.vue?vue&type=template&id=4a178bcc&"
import script from "./ProcessNachtragHeader.vue?vue&type=script&lang=js&"
export * from "./ProcessNachtragHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports